import React from "react";
import { useTheme } from "@emotion/react";
import { Paper, Typography, Box, CircularProgress } from "@mui/material";
import { alpha } from "@mui/system";
import {
	CheckCircleOutlineOutlined,
	CalendarMonthOutlined,
	ReportOutlined,
	RestartAltOutlined,
} from "@mui/icons-material";

export default function CardReport({
	cardTile,
	cardValue,
	status = "Gerados",
}) {
	const theme = useTheme();

	const getStatusConfig = (currentStatus) => {
		const iconProps = { fontSize: "medium" };

		switch (currentStatus?.toLowerCase()) {
			case "gerados":
			case "concluído":
				return {
					color: theme.palette.success.main, // Verde
					bgColor: alpha(theme.palette.success.main, 0.2),
					icon: <CheckCircleOutlineOutlined {...iconProps} />,
				};
			case "agendados":
				return {
					color: theme.palette.warning.main, // Amarelo
					bgColor: alpha(theme.palette.warning.main, 0.2),
					icon: <CalendarMonthOutlined {...iconProps} />,
				};
			case "em execução":
				return {
					color: theme.palette.info.main, // Azul
					bgColor: alpha(theme.palette.info.main, 0.2),
					icon: <RestartAltOutlined {...iconProps} />,
				};
			case "falha":
				return {
					color: theme.palette.error.main, // Vermelho
					bgColor: alpha(theme.palette.error.main, 0.2),
					icon: <ReportOutlined {...iconProps} />,
				};
			default:
				return {
					color: theme.palette.text.secondary,
					bgColor: alpha(theme.palette.text.secondary, 0.2),
					icon: null,
				};
		}
	};

	const config = getStatusConfig(status);

	return (
		<Paper
			elevation={theme.palette.mode === "dark" ? 0 : 2}
			sx={{
				backgroundColor: theme.palette.background.paper,
				borderTop: `5px solid ${config.color}`,
				borderRadius: 3,
				minWidth: "150px",
				padding: "16px",
				display: "flex",
				position: "relative",
				overflow: "hidden",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 2,
					width: "100%",
				}}
			>
				<Box
					sx={{
						backgroundColor: config.bgColor,
						borderRadius: "8px",
						width: "41px",
						height: "41px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						color: config.color,
						flexShrink: 0,
					}}
				>
					{config.icon}
				</Box>

				<Box sx={{ display: "flex", flexDirection: "column" }}>
					<Typography
						variant="h4"
						sx={{
							fontWeight: "bold",
							color: theme.palette.text.primary,
							lineHeight: 1.2,
							fontSize: "32px",
						}}
					>
						{cardValue}
					</Typography>

					<Typography
						variant="body2"
						sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}
					>
						{cardTile}
					</Typography>
				</Box>
			</Box>
		</Paper>
	);
}
